// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D0Ur","inner":"styles_inner__1qKrr","right":"styles_right__oaOiS","close":"styles_close__HjtgQ","footer":"styles_footer__3e9Hi"};